// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ScrollingTextWrapper_wrapper__2919r","scrollable":"ScrollingTextWrapper_scrollable__Fxelv"};